export function getUtcHourFromLocalHour(localHour: number, localMinute = 0) {
	
	// Basic validation for hour and minute
	if (typeof localHour !== 'number' || localHour < 0 || localHour > 23 || !Number.isInteger(localHour)) {
		console.error("Invalid 'localHour'. Expected an integer between 0 and 23.");
		return null;
	}
	if (typeof localMinute !== 'number' || localMinute < 0 || localMinute > 59 || !Number.isInteger(localMinute)) {
		console.error("Invalid 'localMinute'. Expected an integer between 0 and 59.");
		return null;
	}

	// Get today's date parts in the browser's local timezone
	const now = new Date();
	const year = now.getFullYear();
	const month = now.getMonth(); // 0-indexed month for Date constructor
	const day = now.getDate();

	// Create a Date object representing the local time on the current day
	// The Date constructor will interpret these numbers in the *browser's local timezone*.
	const localDateObj = new Date(year, month, day, localHour, localMinute, 0, 0);

	// Check for "Invalid Date"
	if (isNaN(localDateObj.getTime())) {
		console.error("Failed to construct local Date object with inputs:", localHour, localMinute);
		return null;
	}

	// Get the UTC hour component from the Date object
	return localDateObj.getUTCHours();
}	

export function getLocalHourFromUtcHour(utcHour: number, utcMinute = 0) {
	// Basic validation for hour and minute
	if (typeof utcHour !== 'number' || utcHour < 0 || utcHour > 23 || !Number.isInteger(utcHour)) {
		console.error("Invalid 'utcHour'. Expected an integer between 0 and 23.");
		return null;
	}
	if (typeof utcMinute !== 'number' || utcMinute < 0 || utcMinute > 59 || !Number.isInteger(utcMinute)) {
		console.error("Invalid 'utcMinute'. Expected an integer between 0 and 59.");
		return null;
	}

	// Get today's date parts in the browser's local timezone
	// We need these to construct a Date object that the local timezone can apply to.
	const now = new Date();
	const year = now.getFullYear();
	const month = now.getMonth(); // 0-indexed month for Date constructor
	const day = now.getDate();

	// Create a Date object representing the specified UTC time on the current date.
	// Date.UTC() creates a Date object that internally represents UTC.
	// The arguments to Date.UTC() are interpreted as UTC values.
	const utcTimestamp = Date.UTC(year, month, day, utcHour, utcMinute, 0, 0);

	// Create a Date object from this UTC timestamp.
	// When instantiated from a timestamp, the Date object internally holds that exact moment.
	// getHours() will then convert that internal UTC moment to the local timezone.
	const utcDateObj = new Date(utcTimestamp);

	// Check for "Invalid Date"
	if (isNaN(utcDateObj.getTime())) {
		console.error("Failed to construct UTC Date object with inputs:", utcHour, utcMinute);
		return null;
	}

	// Get the local hour component from the Date object
	return utcDateObj.getHours();
}

export function utcToBrowserTime(utcDateString : string) {

	if (!utcDateString || typeof utcDateString !== 'string') {
	  console.error("Invalid input: utcDateString must be a non-empty string.");
	  return null;
	}
  
	// Create a Date object from the UTC string.
	// The Date constructor correctly parses ISO 8601 strings (ending with 'Z' or a UTC offset)
	// and internally stores the exact moment in time (milliseconds since epoch).
	const dateObj = new Date(utcDateString);
  
	// Check if the date object is valid
	if (isNaN(dateObj.getTime())) {
	  console.error(`Invalid date string provided: ${utcDateString}`);
	  return null;
	}
  
	// At this point, `dateObj` holds the precise moment in time.
	// When you use `dateObj.toLocaleString()` or `dateObj.getHours()`, etc.,
	// JavaScript automatically applies the browser's local timezone for output.
	return dateObj;
  }